// @flow
import type { Element, Node } from 'react';

import React from 'react';
import RequireAuthorization from '#components/support/routing/RequireAuthorization/index.jsx';
import { MODELS } from '#constants/pathStrings.js';

type Props = {|
  children: Node,
  step: 'decide' | 'upload',
  currentStep: ?string,
  routeParams: {| modelId: string |},
|};

/*
 * One-shot guard for the create flow's decision/upload interstitial (HBR-4950 #316 decisions 3/4):
 * renders children only while the store's ephemeral createModelFlow step for this route's model
 * matches `step`. Any other value -- including the missing step a refresh, deep link, or "No"/
 * Cancel leaves behind, since the store slice is never persisted (see
 * reducers/ui/createModelFlow) -- redirects into the model instead. `replace` so the decision/
 * upload route never lands in browser history as a revisitable step.
 */
const RequireCreateModelFlowStep = ({
  children,
  step,
  currentStep,
  routeParams,
}: Props): Element<typeof RequireAuthorization> => (
  <RequireAuthorization
    isAuthorized={currentStep === step}
    redirectTo={`/${MODELS}/${routeParams.modelId}`}
    replace
  >
    {children}
  </RequireAuthorization>
);

export default RequireCreateModelFlowStep;
